import PageContainer from "../../components/PageContainer";
import { useAppDispatch, useAppSelector } from "../../../hooks/useRedux";
import CustomButton from "../../components/CustomButton";
import { setOpenSidebar } from "../../../redux/features/settingSlice";
import Sidbar from "../../containers/Sidebar";
import { Box, Button, Typography, useTheme } from "@mui/material";
import home_road from "../../../media/images/home_road.png";
import LogoImage from "../../../media/images/icons/logo.svg";
import LoginIcon from "../../../media/images/icons/login-newsvg";
import AuthFooter from "../../layout/AuthLayout/Footer";
import MedalIcon from "../../../media/images/icons/medal-icon";
import ShareIcon from "../../../media/images/icons/share-icon";
import UserRegister from "../../../media/images/icons/userRegister";
import PlusMiniIcon from "../../../media/images/icons/plus-mini";
import CoverPng from "../../../media/images/courseCover.png";
import HamMenuIcon from "../../../media/images/icons/hambergerMenu";
import NotifsIcon from "../../../media/images/icons/notification-bing";
import LoginModal from "./LoginModal";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import useVirtualViewport from "../../../hooks/useVirtualViewport";
import Header from "./Header";
import AuthSidebar from "../../layout/AuthLayout/Sidbar";
import ManageOrders from "../../../media/images/icons/manage-orders";

const HomePage = () => {
  const { openSidebar } = useAppSelector((state) => state.setting);
  const dispatch = useAppDispatch();
  const theme = useTheme();

  const navigate = useNavigate();

  const [loginModal, setLoginModal] = useState(false);

  const viewport = useVirtualViewport();

  return (
    <Box
      sx={{
        direction: "rtl",
        maxWidth: "600px",
        height: `${viewport?.height}px`,
        width: {
          xs: "100%",
        },
        marginX: "auto",
        display: "flex",
        flexDirection: "column",
        // justifyContent: "space-between",
      }}
    >
      <LoginModal open={loginModal} handleClose={() => setLoginModal(false)} />
      <Header />
      <AuthSidebar />
      <Box
        sx={{
          flex: 1,
          overflow: "auto",
          height: "100%",
          width: "100%",
          display: "flex",
          flexDirection: "column",
          paddingX: "8px",
          justifyContent: "space-around",
        }}
      >
        <Box
          sx={{
            marginTop: "32px",
            // border: "1px solid gray",
            position: "relative",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Box
            sx={{
              zIndex: 20,
              boxShadow: "0px 4px 8px 0px rgba(0, 0, 0, 0.10)",

              width: "fit-content",
              position: "absolute",
              bottom: "-10%",
              borderRadius: "20px",
              backgroundColor: "background.default",
              padding: "2px",
              display: "flex",
              alignItems: "center",
              gap: "8px",
              justifyContent: "center",
            }}
          >
            <Box
              sx={{
                backgroundColor: "info.light",
                borderRadius: "20px",
                display: "flex",
                padding: "6px",
                gap: "8px",

                alignItems: "center",
              }}
            >
              <img src={LogoImage} alt="" />

              <Typography
                variant="h5"
                sx={{
                  color: "secondary.main",
                }}
              >
                کارن ترابرنت
              </Typography>
            </Box>
          </Box>
          <Box
            sx={{
              position: "absolute",
              // border: "1px solid gray",
              bottom: "20%",
              width: "90%",
              display: "flex",
              alignItems: "start",
              minHeight: "150px",
              justifyContent: "space-between",
              gap: {
                xs: "10px",
              },
            }}
          >
            <Box
              sx={{
                padding: "8px",
                backgroundColor: "background.default",
                borderRadius: "16px",
                display: "flex",
                alignItems: "center",
                boxShadow: "0px 4px 15px 3px rgba(0,0,0,0.1)",
                alignSelf: "end",
                gap: "3px",
              }}
            >
              {/* <img width={100} src={CoverPng} alt="" /> */}
              <ManageOrders size={20} color={theme.palette.primary.main} />
              <Typography color={"primary.main"} variant="body1">
                مدیریت سفارشات
              </Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "end",
                gap: "10px",
              }}
            >
              <Box
                sx={{
                  padding: "8px",
                  display: "flex",
                  alignItems: "center",
                  marginLeft: "8px",
                  backgroundColor: "background.default",
                  borderRadius: "16px",
                  boxShadow: "0px 4px 15px 3px rgba(0,0,0,0.1)",
                }}
              >
                <MedalIcon size={20} color={theme.palette.primary.main} />

                <Typography
                  variant="body1"
                  sx={{
                    color: "primary.main",
                  }}
                >
                  باشگاه مشتریان{" "}
                </Typography>
              </Box>
              <Box
                sx={{
                  // position: "absolute",
                  // left: "-50px",
                  // bottom: "20%",
                  padding: "8px",
                  display: "flex",
                  alignItems: "center",
                  backgroundColor: "background.default",
                  borderRadius: "16px",
                  boxShadow: "0px 4px 15px 3px rgba(0,0,0,0.1)",
                }}
              >
                <ShareIcon size={20} color={theme.palette.secondary.main} />

                <Typography
                  sx={{
                    color: "secondary.main",
                    fontWeight: "bolder",
                  }}
                >
                  اشتراک گزاری بار{" "}
                </Typography>
              </Box>
            </Box>
          </Box>

          <img src={home_road} alt="" />
        </Box>
        <Box
          sx={{
            // border: "1px solid gray",
            display: "flex",
            marginX: "auto",
            width: "80%",
            flexDirection: "column",
            gap: "8px",
          }}
        >
          <CustomButton
            // loading={loading}
            onClick={() => setLoginModal(true)}
            flexDirection="row"
            title="ورود به اپلیکیشن"
            justifyContent="space-between"
            bgColor="primary.main"
            width="100%"
            fSize="16px"
            fontWeight={500}
            px="10px"
            py="10px"
            borderRadius="10px"
            color="lightStatic.main"
            icon2={<LoginIcon size={32} />}
            mt="16px"
          />
          <Box>
            <CustomButton
              // loading={loading}
              onClick={() => navigate("/complete-info")}
              flexDirection="row-reverse"
              title="ثبت نام رانندگان و صاحبین بار"
              justifyContent="start"
              bgColor="secondary.main"
              width="100%"
              fSize="16px"
              fontWeight={500}
              px="10px"
              py="10px"
              borderRadius="10px"
              color="lightStatic.main"
              icon2={<UserRegister size={32} />}
              mt="16px"
            />
            <CustomButton
              // loading={loading}
              // onClick={formik.handleSubmit}
              flexDirection="row-reverse"
              title="ثبت نام شرکت حمل و نقل"
              justifyContent="start"
              bgColor="secondary.main"
              width="100%"
              fSize="16px"
              fontWeight={500}
              px="10px"
              py="10px"
              borderRadius="10px"
              color="lightStatic.main"
              icon2={<PlusMiniIcon size={32} />}
              mt="8px"
            />
          </Box>
        </Box>
        <AuthFooter />
      </Box>
    </Box>
  );
};

export default HomePage;
